import './index.css';
import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
* {
  margin: 0;
  font-family: 'Google Sans', 'Yati';
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000000;
}

#root {
  width: 100vw;
  overflow-x: hidden;
  max-width: 480px;
  height: 100vh;
  background: ${(props) => props.theme.backgroundColor};   
}

.ant-input-affix-wrapper:not(.ant-input-status-error) {
  border: 1px solid #5C5C5C !important;
}

.ant-input-affix-wrapper:hover, .ant-input:hover {
  border: 1.5px solid #5C5C5C !important;
}

.ant-input-affix-wrapper {
  border-radius: 8x !important;
  background: #F4F4F4 !important;

  color: #1E1E1E !important;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; 
}

input::placeholder {
  color: #9F9F9F !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
}

.ant-spin-dot i {
  background: ${(props) => props.theme.primaryColor} !important;
}

.ant-modal:not(.custom-calendar-modal):not(.lang-modal):not(.pocket-money-modal) {
    
  .ant-modal-content {
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 95px 16px 16px 16px;
    border-radius: 16px;
    background: #FFF;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.10);
  }

  .ant-modal-body {
    padding: 0px 6px;
    color: var(--color-inverse, #2A2A2A);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 26px; /* 162.5% */
  }

  .ant-modal-header {
    background: transparent !important;
    margin: 0;
  }

  .ant-modal-title {
    background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%) !important;
    background-clip: text !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 145.455% */
  }

  .ant-modal-footer {
    margin: 0;
    display: flex;
    justify-content: center;
    gap: 16px;

    .ant-btn-default {
      flex: 1;
      width: 100%;
      padding: 0 !important;
      margin: 0 !important;
      height: 50px !important;
      border-radius: 8px !important;
      background: #fff !important;
      border: 1px solid #D66700 !important;

      color: #D66700 !important;
      text-align: center;
      font-size: 16px !important;
      font-style: normal;
      font-weight: 700 !important;
      line-height: 26px; /* 162.5% */
    }

    .ant-btn-primary {
      flex: 1;
      width: 100%;
      padding: 0 !important;
      margin: 0 !important;
      height: 50px !important;
      border-radius: 8px !important;
      background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%);

      color: #2A2A2A;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px; /* 162.5% */
    }
  }

  #modal-icon {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translate(-50%,0);
  }
}

.ant-btn-primary:not(.ant-btn-dangerous) {
  background: ${(props) => props.theme.buttonColor};
  box-shadow: none;
  border-radius: 8px;
  width: 100%;
  border: none !important;

  color: #2A2A2A !important;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */

  :hover {
    background: ${(props) => props.theme.buttonHoverColor};
    border: none !important;
  }

  :disabled {
    color: #2A2A2A !important;
    background-color: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%) !important;
    opacity: 0.5;

    :hover {
      background: ${(props) => props.theme.buttonColor};
    }
  }
}

.ant-btn-primary:not(:disabled):not(.ant-btn-disabled):hover{
  background: ${(props) => props.theme.buttonHoverColor};
}

.ant-btn-default {
  border-radius: 8px !important;
  background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%) !important;
  border: none !important;
  border-radius: 12px;

  color: #2A2A2A !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;

  :hover {
    background: linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%) !important;
    color: #2A2A2A !important;
    border: none !important;
  }
}

.ant-btn-outline {
  border-radius: 8px;
  background: transparent !important;
  border: none !important;
  border-radius: 12px;
  border-radius: 8px;
  border: 1px solid  #D66700 !important;

  color: #D66700 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;

  :hover {
    background: transparent !important;
    color: #D66700 !important;
  }
}

.ant-table-wrapper {
  
  tr:nth-child(2n) {
    td {
      background-color: #E1CCE0;
    }

    :hover {
      td {
        background-color: #E1CCE0 !important;
      }
    }
  }

  tr {
      >td {
        background-color: ${(props) => props.theme.backgroundColor};

        font-size: 14px;
        font-weight: normal;
        color: #000000;

        :first-child, :last-child {
          padding: 8px 24px !important;
        }
    }

    :hover {
      >td {
        background-color: ${(props) => props.theme.backgroundColor} !important;
      }
    }
  }

  tr>th {
    background-color: #71207C !important;
    font-size: 14px !important;
    font-weight: normal !important;
    color: #FFFFFF !important;

    ::before {
      display: none;
    }

    :first-child {
      border-start-start-radius: 5px !important;
      border-end-start-radius: 5px !important;
      padding: 8px 24px !important;
    }

    :last-child {
      border-start-end-radius: 5px !important;
      border-end-end-radius: 5px !important;
      padding: 8px 24px !important;
    }
  }
}

.ant-radio-wrapper .ant-radio-checked {
    
  ::after {
    border: 1px solid ${(props) => props.theme.primaryColor};
  }

  .ant-radio-inner {
    border-color: ${(props) => props.theme.primaryColor};
    background-color: ${(props) => props.theme.primaryColor};
  }
}

.ant-picker-calendar {
    .ant-radio-group {
        display: none !important;
    }
}

.ant-notification-notice {
  padding: 12px !important;
}

.ant-notification-notice-close {
  top: 12px !important;
}

.ant-notification-notice-description {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
-ms-overflow-style: none;  /* IE and Edge */
scrollbar-width: none;  /* Firefox */

.otp-length-8 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 5px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
  }
}

.otp-length-6 {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 2px;

  @media screen and (max-width: 290px) {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.custom-calendar-modal {

  .ant-modal-footer {
      text-align: center;
  }

  @media screen and (max-width: 325px) {
    .ant-modal-content {
      padding: 20px 0 !important;
    }
  }
  
}

.trx-history-dropdown {
  background-color: #EFEFEF;

  .ant-select-item-option {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: #101415;
  }
}

.ant-drawer-content-wrapper {
    height: auto !important;
}

.ant-form-item-explain-error {
  font-size: 12px;
}

.ant-result {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .ant-result-icon{
    margin-bottom: 0;
  }

  .ant-result-title {
    color: #2A2A2A;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 155.556% */
  }

  .ant-result-subtitle {
    color: #5C5C5C;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 155.556% */
  }

  .ant-result-extra{
    width: 100% !important;

    .ant-btn {
      height: 50px !important;
    }
  }

}

input {
    font-family: Inter !important;
    font-size: 16px;
    font-weight: 400;

    ::placeholder {
      font-family: Inter !important;
      color: #9B92BB !important;
    }
}

.ant-input:focus::placeholder {
    color: transparent !important;
  }

.grecaptcha-badge { visibility: hidden; }
`;

export default GlobalStyles;
